import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-statistique-timeline-card',
  templateUrl: './statistique-timeline-card.component.html',
  styleUrls: ['./statistique-timeline-card.component.css']
})
export class StatistiqueTimelineCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
